module.exports = __webpack_public_path__ + "static/fonts/template1.5986589.docx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template1.docx
// module id = 369
// module chunks = 1